import {
	createSystem, defaultConfig, defineConfig,
} from '@chakra-ui/react';

import { webDesignSystemConfig } from '@packages/web-design-systems';

import { recipes } from './recipes';
import { slotRecipes } from './slot-recipes';
import { tokens } from './tokens';

const config = defineConfig({
	theme: {
		recipes,
		slotRecipes,
		tokens,
		semanticTokens: {
			colors: {
				primary: {
					contrast:   { value: '{colors.white}' },
					emphasized: { value: '{colors.primary.120}' },
					fg:         { value: '{colors.white}' },
					focusRing:  { value: '{colors.primary.120}' },
					muted:      { value: '{colors.gray.50}' },
					solid:      { value: '{colors.primary.100}' },
					subtle:     { value: '{colors.primary.10}' },
				},
				secondary: {
					contrast:   { value: '{colors.white}' },
					emphasized: { value: '{colors.secondary.120}' },
					fg:         { value: '{colors.white}' },
					focusRing:  { value: '{colors.secondary.120}' },
					muted:      { value: '{colors.gray.50}' },
					solid:      { value: '{colors.secondary.100}' },
					subtle:     { value: '{colors.secondary.100}' },
				},
				tertiary: {
					contrast:   { value: '{colors.white}' },
					emphasized: { value: '{colors.tertiary.120}' },
					fg:         { value: '{colors.white}' },
					focusRing:  { value: '{colors.tertiary.120}' },
					muted:      { value: '{colors.gray.50}' },
					solid:      { value: '{colors.tertiary.100}' },
					subtle:     { value: '{colors.tertiary.100}' },
				},
			},
		},
	},
});

export const candidateDesignSystem = createSystem(defaultConfig, webDesignSystemConfig, config);

export default candidateDesignSystem;
